import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthenticatedGuard } from './guards/authenticated.guard';
import { MenuPage } from './pages/menu/menu.page';
import { MenuPageModule } from './pages/menu/menu.module';
import { InvoicesResolverService } from './resolvers/invoices-resolver.service';
import { LocationsResolver } from './resolvers/locations-resolver';
import { AdminGuard } from './guards/admin.guard';
import { B2bRedirectorGuard } from './guards/b2b-redirector.guard';

const routes: Routes = [
  { path: '', redirectTo: 'track', pathMatch: 'full' },
  {
    path: 'login',
    loadChildren: () => import('./pages/login/login.module').then( m => m.LoginPageModule)
  },
  {
    path: '',
    component: MenuPage,
    // original guard
    // canActivate: [ AuthenticatedGuard ],
    //this seems to be introducing login errors, need to debug:
    // canActivate: [ AuthenticatedGuard, AdminGuard ],
    children: [
      {
        path: 'quote',
        loadChildren: () => import('./pages/quote/quote.module').then( m => m.QuotePageModule),
        resolve: {
          locations: LocationsResolver
        }
      },
      {
        path: 'track',
        canActivate: [ B2bRedirectorGuard , AuthenticatedGuard ],
        loadChildren: () => import('./pages/track/track.module').then( m => m.TrackPageModule),
      },    
      {
        path: 'pay', // alias for B2b
        canActivate: [ AuthenticatedGuard ],
        loadChildren: () => import('./pages/track/track.module').then( m => m.TrackPageModule),
      },    
      {
        path: 'account',
        canActivate: [ AuthenticatedGuard ],
        loadChildren: () => import('./pages/userinfo/userinfo.module').then( m => m.UserinfoPageModule)
      },
      {
        path: 'pay/:token',
        canActivate: [ AuthenticatedGuard ],
        loadChildren: () => import('./pages/pay/pay.module').then( m => m.PayPageModule)
      },
      {
        path: 'admin',
        canActivate: [ AuthenticatedGuard, AdminGuard ],
        loadChildren: () => import('./pages/admin/admin.module').then( m => m.AdminPageModule)
      },
      {
        path: 'checkout',
        canActivate: [ AuthenticatedGuard ],
        loadChildren: () => import('./pages/uta-checkout/uta-checkout.module').then( m => m.UtaCheckoutPageModule)
      },
      {
        path: 'process-payment',
        canActivate: [ AuthenticatedGuard ],
        loadChildren: () => import('./pages/process-payment/process-payment.module').then( m => m.ProcessPaymentPageModule)
      },
    ]
  },
  {
    path: 'register',
    loadChildren: () => import('./pages/register/register.module').then( m => m.RegisterPageModule),
    resolve: {
      locations: LocationsResolver
    }
  },
  {
    path: 'quote/inline',
    loadChildren: () => import('./pages/inline-quote/inline-quote.module').then( m => m.InlineQuotePageModule),
    resolve: {
      locations: LocationsResolver
    },
  },
  {
    path: 'forgot-password',
    loadChildren: () => import('./pages/forgot-password/forgot-password.module').then( m => m.ForgotPasswordPageModule)
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules }),
    MenuPageModule
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
